export const PHONE_NUMBER = `855-802-8746`;
export const FAX_NUMBER = `855-454-8746`;
export const ESCALATION_EMAIL = ' QutenzaEscalations@cmcopilot.com';
